const flickity = (() => {

  var flickitySlider = document.getElementsByClassName('contentCarousel');
  if (flickitySlider.length > 0) {

      // external js: flickity.pkgd.js
      var utils = window.fizzyUIUtils;

      var contentCarousel = document.querySelector('.contentCarousel');
      var flkty = new Flickity( contentCarousel, {
          pageDots: true,
          prevNextButtons: false,
          cellSelector: '.carousel-cell'
      });
  }

})();

export default flickity;